'use strict';

var version = require('./version');
var AnalysisGraph = require('./analysis-graph');

module.exports.getVersion = version.getVersion;
module.exports.versions = version.versions;
module.exports.AnalysisGraph = AnalysisGraph;



//////////////////
// WEBPACK FOOTER
// ./~/camshaft-reference/index.js
// module id = 378
// module chunks = 6